import React from 'react';
import { useUiTheme } from 'framework/uiTheme';

type AlertErrorsForFormListProps = {
  isShow: boolean;
  onClose: () => void;
  textContent: string;
};

const AlertErrorsForFormList = ({ isShow, onClose, textContent }: AlertErrorsForFormListProps) => {
  const { Alert } = useUiTheme();
  if (!isShow) return null;
  return (
    <Alert onClose={onClose} severity="error">
      {textContent}
    </Alert>
  );
};

export default AlertErrorsForFormList;
